module.exports = __webpack_public_path__ + "static/media/Earn-higher.0484d0c7.jpg";